import tenantUtils from '@utils';
import { getUnifiedTruLeadsStaffDateRangeFilterItem } from '../../common/utils/unifiedTruLeadsLeadFilters';
import { getTimeDateString } from '../../../utility/date';
import { isUnifiedProfolioEnabled } from '../../../utility/user';
import { t } from 'i18next';

const defaultLeadDateRangeFilters = [
  {
    label: t('Lead Received'),
    key: 'lead_received',
    queryParamKey: ['f[created_at][gte]', 'f[created_at][lte]'],
    placeholder: t('Select Date Range'),
    type: 'dateRange',
    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
  {
    label: t('Last Interaction'),
    key: 'last_interaction',
    queryParamKey: ['f[updated_at][gte]', 'f[updated_at][lte]'],
    placeholder: t('Select Date Range'),
    type: 'dateRange',

    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
];

const getLeadsStaffFilters = (users) => [
  {
    type: 'unitSelect',
    label: 'Search By',
    key: 'search',
    subList: [
      { label: t('Listing ID'), key: 'listing_id', queryParamKey: 'q[interests_listing_id_eq]' },
      { label: t('Lead Name'), key: 'lead_name', queryParamKey: 'q[name_start]' },
    ],
  },
  ...(isUnifiedProfolioEnabled({ featureKey: 'listingsUnified' })
    ? [getUnifiedTruLeadsStaffDateRangeFilterItem()]
    : defaultLeadDateRangeFilters),
  ...(users?.length > 1
    ? [
        {
          key: 'user_id',
          queryParamKey: 'f[user_id]',
          label: t('Users'),
          labelProps: { muted: true },
          placeholder: t('Select Users'),
          type: 'select',
          list: users,
          showTag: true,
          singleValue: true,
          getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'name'),
          getOptionValue: (op) => op.id.toString(),
        },
      ]
    : []),
];
export default getLeadsStaffFilters;
